import React from 'react';
import PropTypes from 'prop-types';

import DarkThemedLoader from 'components/DarkThemedLoader';
import ContentLoader from '../ContentLoader';

class ConditionalLoader extends React.Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired
  };

  render() {
    const { loading, children, fullScreen = false, mode } = this.props;

    return loading ? (
      mode === 'dark' ? (
        <DarkThemedLoader />
      ) : (
        <ContentLoader fullScreen={fullScreen} />
      )
    ) : (
      <React.Fragment>{children}</React.Fragment>
    );
  }
}

export default ConditionalLoader;
